// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputWrapper-module_inputWrapper__cLD4S {
    /* Colors (--iw-border-color, --iw-input-color, …) are set inline from the widget's design version: see INPUT_WRAPPER_COLOR_VARS. */
    --iw-font-family: var(--font-main);
    --iw-font-size: var(--typography-main-size);
    --iw-font-weight: var(--typography-main-weight);
    --iw-line-height: var(--typography-main-line-height);
    --iw-letter-spacing: normal;
    --iw-border-radius: 6px;
    --top: 16px;
    --padding: 16px;
}

.inputWrapper-module_hintContainer__n1yQg {
    font-family: var(--iw-font-family), sans-serif;
    font-size: var(--typography-secondary-size);
    line-height: var(--typography-secondary-line-height);
    color: var(--iw-hint-color);
    margin-top: 8px;
    margin-left: 16px;
    margin-right: 16px;
    justify-content: flex-start;
    display: flex;

    &.inputWrapper-module_linedInputForHintContainer__ZfLvp {
        margin-left: 0;
    }
}

.inputWrapper-module_alignCenter__oJNqg {
    justify-content: center;
}

.inputWrapper-module_hintButton__KkoGp {
    margin-top: -4px;
    margin-left: 4px;
}

.inputWrapper-module_hintContainer__n1yQg.inputWrapper-module_disabledColor__lqzlY,
.inputWrapper-module_inputLabel__W4mnJ.inputWrapper-module_disabledColor__lqzlY {
    color: var(--iw-disabled-color);

    input,
    input[type='search'],
    textarea {
        color: var(--iw-disabled-color);

        &:hover {
            color: var(--iw-disabled-color);
        }
    }
}

.inputWrapper-module_errorColor__QAOfL {
    color: var(--iw-error-color);
}

.inputWrapper-module_inputRightElement__KPkQV {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: var(--zindex-input-right-element);
}

.inputWrapper-module_isLinedInput__ZmSvN {
    right: -8px;
}

.inputWrapper-module_isSearchInput__Fy4XS {
    top: 24px;
}

.inputWrapper-module_floatingLabel__Ako5A {
    font-family: var(--iw-font-family), sans-serif;
    font-size: var(--iw-font-size);
    line-height: var(--iw-line-height);
    letter-spacing: var(--iw-letter-spacing);
    position: absolute;
    top: var(--top);
    left: 8px;
    background: var(--iw-label-background);
    transition: top 0.2s;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 16px);
    box-sizing: border-box;
    padding: 0 8px;
}

.inputWrapper-module_floatingLabelLinedInput__lQ95u {
    left: 0;
    padding: 0;
}

.inputWrapper-module_floatingLabelFilledOrFocused__C13MQ {
    font-size: var(--typography-secondary-size);
    line-height: var(--typography-secondary-line-height);
}

.inputWrapper-module_inputLabel__W4mnJ {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    padding: var(--padding);
    z-index: var(--zindex-input-label);

    input[type='search' i]::-webkit-search-cancel-button {
        -webkit-appearance: none;
    }

    /* hide arrow for number input */
    input[type='number']::-webkit-outer-spin-button,
    input[type='number']::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* hide arrow for number input */
    input[type='number'] {
        -moz-appearance: textfield;
        appearance: textfield;
    }

    input,
    input[type='search'],
    textarea {
        font-family: var(--iw-font-family), sans-serif;
        font-size: var(--iw-font-size);
        line-height: var(--iw-line-height);
        letter-spacing: var(--iw-letter-spacing);
        padding: 0;
        background-color: transparent;
        border: none;
        box-sizing: border-box;
        display: inline-block;
        width: 100%;
        text-overflow: ellipsis;
        cursor: auto;
        color: var(--iw-input-color);
        outline: none;

        &:hover {
            color: var(--iw-input-color);
        }
    }
}

.inputWrapper-module_inputLabelSearchInput__CfezP {
    background: var(--iw-label-background);
}

.inputWrapper-module_inputLabelDropdownInput__YjMsE {
    cursor: pointer;

    input,
    input[type='search'],
    textarea {
        cursor: pointer;
    }
}

.inputWrapper-module_inputLabelLinedInput__yJmm_ {
    input,
    input[type='search'],
    textarea {
        padding: 24px 0 0 0;
    }
}

.inputWrapper-module_inputLabelInputAlignCenter__Bj4Dh {
    input,
    input[type='search'],
    textarea {
        text-align: center;
    }
}

.inputWrapper-module_inputContainer__MFIAU {
    font-family: var(--iw-font-family), sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: relative;
    background: var(--iw-background);
    border: 1px solid var(--iw-border-color);
    border-radius: var(--iw-border-radius);

    &:after {
        content: '';
        position: absolute;
        width: calc(100% - 4px);
        height: 1px;
        bottom: 0;
        left: 2px;
    }

    &:before {
        content: none;
        position: absolute;
        width: calc(100% - 8px);
        margin-left: 4px;
        height: 16px;
        z-index: var(--zindex-input-shadow);
        box-shadow: var(--shadow_grey);
    }
}

.inputWrapper-module_inputContainer__MFIAU.inputWrapper-module_inputContainerReadOnly__cjlW2 {
    cursor: default;
    pointer-events: none;
}

.inputWrapper-module_inputContainerLinedInput__F4Uw1 {
    border-left: none;
    border-right: none;
    border-top: none;
    border-radius: 0;

    &:after {
        width: 100%;
        left: 0;
    }
}

.inputWrapper-module_inputContainerError___Eb0X {
    border-bottom: 1px solid var(--iw-border-color-error);

    &:after {
        background: var(--iw-border-color-error);
    }
}

.inputWrapper-module_inputContainerFocused__YEg2p {
    border-bottom: 1px solid var(--iw-border-color-focus);

    &:after {
        background: var(--iw-border-color-focus);
    }
}

.inputWrapper-module_inputContainerDisabled__gd0Wd {
    pointer-events: none;
    border: 1px dashed var(--iw-border-color-disabled);
}

.inputWrapper-module_searchInputContainer__ffpeS {
    position: sticky;
    z-index: 1;
    top: 0;
}

.inputWrapper-module_inputContainerSearchInput__m0kbQ {
    border: none;

    &:before {
        content: '';
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/Wrapper/inputWrapper.module.css"],"names":[],"mappings":"AAAA;IACI,mIAAmI;IACnI,kCAAkC;IAClC,2CAA2C;IAC3C,+CAA+C;IAC/C,oDAAoD;IACpD,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,8CAA8C;IAC9C,2CAA2C;IAC3C,oDAAoD;IACpD,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,aAAa;;IAEb;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,+BAA+B;;IAE/B;;;QAGI,+BAA+B;;QAE/B;YACI,+BAA+B;QACnC;IACJ;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,0CAA0C;AAC9C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,8CAA8C;IAC9C,8BAA8B;IAC9B,kCAAkC;IAClC,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,sCAAsC;IACtC,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,UAAU;AACd;;AAEA;IACI,2CAA2C;IAC3C,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;;IAElC;QACI,wBAAwB;IAC5B;;IAEA,gCAAgC;IAChC;;QAEI,wBAAwB;QACxB,SAAS;IACb;;IAEA,gCAAgC;IAChC;QACI,0BAA0B;QAC1B,qBAAqB;IACzB;;IAEA;;;QAGI,8CAA8C;QAC9C,8BAA8B;QAC9B,kCAAkC;QAClC,wCAAwC;QACxC,UAAU;QACV,6BAA6B;QAC7B,YAAY;QACZ,sBAAsB;QACtB,qBAAqB;QACrB,WAAW;QACX,uBAAuB;QACvB,YAAY;QACZ,4BAA4B;QAC5B,aAAa;;QAEb;YACI,4BAA4B;QAChC;IACJ;AACJ;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,eAAe;;IAEf;;;QAGI,eAAe;IACnB;AACJ;;AAEA;IACI;;;QAGI,mBAAmB;IACvB;AACJ;;AAEA;IACI;;;QAGI,kBAAkB;IACtB;AACJ;;AAEA;IACI,8CAA8C;IAC9C,mCAAmC;IACnC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,sCAAsC;;IAEtC;QACI,WAAW;QACX,kBAAkB;QAClB,uBAAuB;QACvB,WAAW;QACX,SAAS;QACT,SAAS;IACb;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,uBAAuB;QACvB,gBAAgB;QAChB,YAAY;QACZ,mCAAmC;QACnC,8BAA8B;IAClC;AACJ;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;;IAEhB;QACI,WAAW;QACX,OAAO;IACX;AACJ;;AAEA;IACI,qDAAqD;;IAErD;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,qDAAqD;;IAErD;QACI,wCAAwC;IAC5C;AACJ;;AAEA;IACI,oBAAoB;IACpB,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,MAAM;AACV;;AAEA;IACI,YAAY;;IAEZ;QACI,WAAW;IACf;AACJ","sourcesContent":[".inputWrapper {\n    /* Colors (--iw-border-color, --iw-input-color, …) are set inline from the widget's design version: see INPUT_WRAPPER_COLOR_VARS. */\n    --iw-font-family: var(--font-main);\n    --iw-font-size: var(--typography-main-size);\n    --iw-font-weight: var(--typography-main-weight);\n    --iw-line-height: var(--typography-main-line-height);\n    --iw-letter-spacing: normal;\n    --iw-border-radius: 6px;\n    --top: 16px;\n    --padding: 16px;\n}\n\n.hintContainer {\n    font-family: var(--iw-font-family), sans-serif;\n    font-size: var(--typography-secondary-size);\n    line-height: var(--typography-secondary-line-height);\n    color: var(--iw-hint-color);\n    margin-top: 8px;\n    margin-left: 16px;\n    margin-right: 16px;\n    justify-content: flex-start;\n    display: flex;\n\n    &.linedInputForHintContainer {\n        margin-left: 0;\n    }\n}\n\n.alignCenter {\n    justify-content: center;\n}\n\n.hintButton {\n    margin-top: -4px;\n    margin-left: 4px;\n}\n\n.hintContainer.disabledColor,\n.inputLabel.disabledColor {\n    color: var(--iw-disabled-color);\n\n    input,\n    input[type='search'],\n    textarea {\n        color: var(--iw-disabled-color);\n\n        &:hover {\n            color: var(--iw-disabled-color);\n        }\n    }\n}\n\n.errorColor {\n    color: var(--iw-error-color);\n}\n\n.inputRightElement {\n    position: absolute;\n    right: 16px;\n    top: 16px;\n    z-index: var(--zindex-input-right-element);\n}\n\n.isLinedInput {\n    right: -8px;\n}\n\n.isSearchInput {\n    top: 24px;\n}\n\n.floatingLabel {\n    font-family: var(--iw-font-family), sans-serif;\n    font-size: var(--iw-font-size);\n    line-height: var(--iw-line-height);\n    letter-spacing: var(--iw-letter-spacing);\n    position: absolute;\n    top: var(--top);\n    left: 8px;\n    background: var(--iw-label-background);\n    transition: top 0.2s;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: calc(100% - 16px);\n    box-sizing: border-box;\n    padding: 0 8px;\n}\n\n.floatingLabelLinedInput {\n    left: 0;\n    padding: 0;\n}\n\n.floatingLabelFilledOrFocused {\n    font-size: var(--typography-secondary-size);\n    line-height: var(--typography-secondary-line-height);\n}\n\n.inputLabel {\n    position: relative;\n    flex: 1;\n    display: flex;\n    align-items: center;\n    padding: var(--padding);\n    z-index: var(--zindex-input-label);\n\n    input[type='search' i]::-webkit-search-cancel-button {\n        -webkit-appearance: none;\n    }\n\n    /* hide arrow for number input */\n    input[type='number']::-webkit-outer-spin-button,\n    input[type='number']::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n\n    /* hide arrow for number input */\n    input[type='number'] {\n        -moz-appearance: textfield;\n        appearance: textfield;\n    }\n\n    input,\n    input[type='search'],\n    textarea {\n        font-family: var(--iw-font-family), sans-serif;\n        font-size: var(--iw-font-size);\n        line-height: var(--iw-line-height);\n        letter-spacing: var(--iw-letter-spacing);\n        padding: 0;\n        background-color: transparent;\n        border: none;\n        box-sizing: border-box;\n        display: inline-block;\n        width: 100%;\n        text-overflow: ellipsis;\n        cursor: auto;\n        color: var(--iw-input-color);\n        outline: none;\n\n        &:hover {\n            color: var(--iw-input-color);\n        }\n    }\n}\n\n.inputLabelSearchInput {\n    background: var(--iw-label-background);\n}\n\n.inputLabelDropdownInput {\n    cursor: pointer;\n\n    input,\n    input[type='search'],\n    textarea {\n        cursor: pointer;\n    }\n}\n\n.inputLabelLinedInput {\n    input,\n    input[type='search'],\n    textarea {\n        padding: 24px 0 0 0;\n    }\n}\n\n.inputLabelInputAlignCenter {\n    input,\n    input[type='search'],\n    textarea {\n        text-align: center;\n    }\n}\n\n.inputContainer {\n    font-family: var(--iw-font-family), sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-end;\n    position: relative;\n    background: var(--iw-background);\n    border: 1px solid var(--iw-border-color);\n    border-radius: var(--iw-border-radius);\n\n    &:after {\n        content: '';\n        position: absolute;\n        width: calc(100% - 4px);\n        height: 1px;\n        bottom: 0;\n        left: 2px;\n    }\n\n    &:before {\n        content: none;\n        position: absolute;\n        width: calc(100% - 8px);\n        margin-left: 4px;\n        height: 16px;\n        z-index: var(--zindex-input-shadow);\n        box-shadow: var(--shadow_grey);\n    }\n}\n\n.inputContainer.inputContainerReadOnly {\n    cursor: default;\n    pointer-events: none;\n}\n\n.inputContainerLinedInput {\n    border-left: none;\n    border-right: none;\n    border-top: none;\n    border-radius: 0;\n\n    &:after {\n        width: 100%;\n        left: 0;\n    }\n}\n\n.inputContainerError {\n    border-bottom: 1px solid var(--iw-border-color-error);\n\n    &:after {\n        background: var(--iw-border-color-error);\n    }\n}\n\n.inputContainerFocused {\n    border-bottom: 1px solid var(--iw-border-color-focus);\n\n    &:after {\n        background: var(--iw-border-color-focus);\n    }\n}\n\n.inputContainerDisabled {\n    pointer-events: none;\n    border: 1px dashed var(--iw-border-color-disabled);\n}\n\n.searchInputContainer {\n    position: sticky;\n    z-index: 1;\n    top: 0;\n}\n\n.inputContainerSearchInput {\n    border: none;\n\n    &:before {\n        content: '';\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWrapper": `inputWrapper-module_inputWrapper__cLD4S`,
	"hintContainer": `inputWrapper-module_hintContainer__n1yQg`,
	"linedInputForHintContainer": `inputWrapper-module_linedInputForHintContainer__ZfLvp`,
	"alignCenter": `inputWrapper-module_alignCenter__oJNqg`,
	"hintButton": `inputWrapper-module_hintButton__KkoGp`,
	"disabledColor": `inputWrapper-module_disabledColor__lqzlY`,
	"inputLabel": `inputWrapper-module_inputLabel__W4mnJ`,
	"errorColor": `inputWrapper-module_errorColor__QAOfL`,
	"inputRightElement": `inputWrapper-module_inputRightElement__KPkQV`,
	"isLinedInput": `inputWrapper-module_isLinedInput__ZmSvN`,
	"isSearchInput": `inputWrapper-module_isSearchInput__Fy4XS`,
	"floatingLabel": `inputWrapper-module_floatingLabel__Ako5A`,
	"floatingLabelLinedInput": `inputWrapper-module_floatingLabelLinedInput__lQ95u`,
	"floatingLabelFilledOrFocused": `inputWrapper-module_floatingLabelFilledOrFocused__C13MQ`,
	"inputLabelSearchInput": `inputWrapper-module_inputLabelSearchInput__CfezP`,
	"inputLabelDropdownInput": `inputWrapper-module_inputLabelDropdownInput__YjMsE`,
	"inputLabelLinedInput": `inputWrapper-module_inputLabelLinedInput__yJmm_`,
	"inputLabelInputAlignCenter": `inputWrapper-module_inputLabelInputAlignCenter__Bj4Dh`,
	"inputContainer": `inputWrapper-module_inputContainer__MFIAU`,
	"inputContainerReadOnly": `inputWrapper-module_inputContainerReadOnly__cjlW2`,
	"inputContainerLinedInput": `inputWrapper-module_inputContainerLinedInput__F4Uw1`,
	"inputContainerError": `inputWrapper-module_inputContainerError___Eb0X`,
	"inputContainerFocused": `inputWrapper-module_inputContainerFocused__YEg2p`,
	"inputContainerDisabled": `inputWrapper-module_inputContainerDisabled__gd0Wd`,
	"searchInputContainer": `inputWrapper-module_searchInputContainer__ffpeS`,
	"inputContainerSearchInput": `inputWrapper-module_inputContainerSearchInput__m0kbQ`
};
export default ___CSS_LOADER_EXPORT___;
